import { BASE_URL } from './config';

export const endpoints = {
  login: `${BASE_URL}/auth/login`,
  resetPassword: `${BASE_URL}/auth/forgetPassword`,
  confirmResetPassword: `${BASE_URL}/auth/validateRecoverPasswordToken`,
  registerUser: `${BASE_URL}/user`,
  confirmEmail: `${BASE_URL}/user/confirmation`,
  registerBusiness: `${BASE_URL}/auth/business`,
  changeUserPassword: `${BASE_URL}/user/password`,
  account: `${BASE_URL}/user`,
  modifyCredentials: `${BASE_URL}/user/credentials`,
  resendConfirmation: `${BASE_URL}/user/unconfirmed`,
  unconfirmed: `${BASE_URL}/user/unconfirmed`,
  verify: `${BASE_URL}/user/verify`,
  collaborators: `${BASE_URL}/user`,
  business: `${BASE_URL}/business`,
  subbusiness: `${BASE_URL}/subbusiness`,
  issuers: `${BASE_URL}/issuers`,
  links: `${BASE_URL}/links`,
  payments: `${BASE_URL}/payments`,
  beginPayment: `${BASE_URL}/payments/beginPay`,
  emailVerification: `${BASE_URL}/user/verification`,
  installments: `${BASE_URL}/installments`,
  clients: `${BASE_URL}/business`,
  billing: `${BASE_URL}/electronicbilling`,
  notifications: `${BASE_URL}/notification`,
  subBusiness: `${BASE_URL}/subbusiness`,
  csv: `${BASE_URL}/links/csv`,
  verifyPayment: `${BASE_URL}/payments/VerifyPay`,
};
